module.exports = global["application_chart_norm"] = require("-!/app/node_modules/ts-loader/index.js??ref--4!./norm.ts");